import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './DesktopTypeContainer';
import { DesktopTypeItem } from './DesktopTypeItem';
import { DesktopTypeItemCount } from './DesktopTypeItemCount';
import { searchConstants } from '../../../search-utils/searchConstants';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import styles from './desktop_type.module.scss';
import { withLanguage } from '../../../../navigation/localization/ContentLanguageContext';
import { searchConstantsUk } from '../../../search-utils/searchConstantsUk';
import { StateType } from '../../../../state/state.types';

type Props = PropsFromRedux & {
  language: string;
};

export class RawDesktopType extends React.Component<Props> {
  typeOfResultChanged = (
    selectedType: keyof StateType['results']['counts'],
  ) => (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent> & {
      ctrlKey: boolean;
      metaKey: boolean;
    },
  ) => {
    if (!event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      this.props.onTypeChanged(selectedType);
      doctrineAnalytics('Search TypeOfResultChanged', {
        type: selectedType,
        source: 'aside',
      });
    }
  };

  getSearchConstants = () => {
    const { language } = this.props;
    if (language === 'fr') {
      return searchConstants;
    }
    return searchConstantsUk;
  };

  render() {
    const { types } = this.getSearchConstants();
    const typesCount = types.length - 1;
    return (
      <div className={styles.menu}>
        {(types as Array<{
          key: keyof StateType['results']['counts'];
          labelId: string;
        }>).map(({ key, labelId }, index: number) => (
          <React.Fragment key={key}>
            <DesktopTypeItem
              type={key}
              onTypeChanged={this.typeOfResultChanged(key)}
            >
              <FormattedMessage id={labelId} />
              <DesktopTypeItemCount type={key} />
            </DesktopTypeItem>

            {index < typesCount && <hr className={styles.separator} />}
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export const DesktopType = withLanguage(Connect(RawDesktopType));
